import { useCallback } from "react";
import {
  useNavigate as useNavigateOriginal,
  type NavigateFunction,
  type NavigateOptions as BaseNavigateOptions,
  type To,
} from "react-router";

import { useMiddleware } from "./useMiddleware";

export type NavigateOptions = BaseNavigateOptions;

export const useNavigate = () => {
  const navigate = useNavigateOriginal();
  const middleware = useMiddleware();

  return useCallback<NavigateFunction>(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === "number") {
        navigate(to);
        return;
      }
      navigate(middleware(to), options);
    },
    [navigate, middleware],
  );
};
